/**
 * Classe base para módulos do widget
 */
class BaseModule {
  constructor(config) {
    this.config = config;
    this.initialized = false;
  }

  /**
   * Inicializa o módulo
   */
  async init() {
    throw new Error('Método init() deve ser implementado pelo módulo');
  }

  /**
   * Renderiza o módulo
   */
  render(container) {
    throw new Error('Método render() deve ser implementado pelo módulo');
  }

  /**
   * Destrói o módulo e limpa recursos
   */
  destroy() {
    this.initialized = false;
  }
}

export default BaseModule;
